import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BoardList } from '../../components/board'
import { LoadingSpinner } from '../../components/common'
import { MainLayout } from '../../components/layout'
import { useDocumentTitle, useWorkspace } from '../../hooks'
import './WorkspaceBoardsPage.css'

/**
 * WorkspaceBoardsPage Component
 * Page for displaying boards within a workspace
 * Implements Requirements 4.1, 4.2
 */
export const WorkspaceBoardsPage: React.FC = () => {
  const { workspaceId } = useParams<{ workspaceId: string }>()
  const navigate = useNavigate()
  const {
    data: workspace,
    isLoading,
    error,
  } = useWorkspace(Number(workspaceId))

  // Set document title with workspace name
  useDocumentTitle('pageTitles.workspaceBoards', {
    workspaceName: workspace?.name || '',
  })

  if (isLoading) {
    return (
      <MainLayout>
        <div className="workspace-boards-page__loading">
          <LoadingSpinner />
        </div>
      </MainLayout>
    )
  }

  if (error || !workspace) {
    return (
      <MainLayout>
        <div className="workspace-boards-page__error">
          <h2>Bo'limlar topilmadi</h2>
          <p>
            Siz izlayotgan bo'lim mavjud emas yoki sizda unga kirish huquqi
            yo‘q.
          </p>
          <button onClick={() => navigate('/workspaces')}>
            Bo'limlarga qaytish
          </button>
        </div>
      </MainLayout>
    )
  }

  return (
    <MainLayout title={workspace.name}>
      <div className="workspace-boards-page">
        <BoardList workspaceId={Number(workspaceId)} />
      </div>
    </MainLayout>
  )
}
